import salesPage from './store';

import cuiIndexCtrl from './index/cui-index.ctrl';
import clientStoreCtrl from './client-store/client-store.ctrl';
import checkoutCtrl from './checkout/checkout.ctrl';
import amazonCheckoutCtrl from './amazon-checkout/amazon-checkout.ctrl';
import payPalCheckoutCtrl from './paypal-checkout/paypal-checkout.ctrl';
import trackOrderCtrl from './track-order/track-order.ctrl';
import OrderSummaryCtrl from './order-summary/order-summary.ctrl';
import cuiContactCtrl from './contact/contact.ctrl';
import PrivacyPolicyCtrl from './legal/privacy-policy/privacy-policy.ctrl';
import CookiePolicyCtrl from './legal/cookie-policy/cookie-policy.ctrl';
import TermsController from './legal/terms-of-service/terms-of-service.ctrl';
import ResetPasswordCtrl from './reset-password/reset-password.ctrl';
import upsellCtrl from './upsell/upsell.ctrl';
import campaignUpsell from './upsell/upsell.dir';
import ThankYouCtrl from './thank-you/thank-you.ctrl';
import CareersController from './careers/careers.ctrl';
import MyAccountCtrl from './my-account/my-account.ctrl';
import OrderHistoryCtrl from './my-account/order-history.ctrl';
import DefaultAddressCtrl from './my-account/default-address.ctrl';
import PaymentMethodsCtrl from './my-account/payment-methods.ctrl';
import trendingProductsCtrl from './trending-products/trending-products.ctrl';

export default angular.module('cui.pages', [ 'cui.pages.sales' ])
  .controller('IndexCtrl', cuiIndexCtrl)
  .controller('ClientStoreCtrl', clientStoreCtrl)
  .controller('UpsellCtrl', upsellCtrl)
  .directive('campaignUpsell', campaignUpsell)
  .controller('CheckoutCtrl', checkoutCtrl)
  .controller('AmazonCheckoutCtrl', amazonCheckoutCtrl)
  .controller('PayPalCheckoutCtrl', payPalCheckoutCtrl)
  .controller('TrackOrderCtrl', trackOrderCtrl)
  .controller('TrendingProductsCtrl', trendingProductsCtrl)
  .controller('OrderSummaryCtrl', OrderSummaryCtrl)
  .controller('ContactCtrl', cuiContactCtrl)
  .controller('CookiePolicyCtrl', CookiePolicyCtrl)
  .controller('PrivacyPolicyCtrl', PrivacyPolicyCtrl)
  .controller('TermsController', TermsController)
  .controller('ResetPasswordCtrl', ResetPasswordCtrl)
  .controller('ThankYouCtrl', ThankYouCtrl)
  .controller('CareersController', CareersController)
  .controller('MyAccountCtrl', MyAccountCtrl)
  .controller('OrderHistoryCtrl', OrderHistoryCtrl)
  .controller('DefaultAddressCtrl', DefaultAddressCtrl)
  .controller('PaymentMethodsCtrl', PaymentMethodsCtrl)
;



// WEBPACK FOOTER //
// ./source/client/pages/index.js